import { consoleRoutes } from "@sagot/constants";
import { useTranslation } from "@sagot/i18n";
import { AppLink } from "@sagot/ui";
import { useWorkspaceContext } from "../../../../../session/workspace-context";

const B = "engage.workflows.defaults.builder";

interface SystemLockNoteProps {
  /** The name of the step the person picked. */
  step: string;
  /** The plan has workflows of the workspace's own: the step is there in a copy. Below it, the note names the plan instead. */
  canDuplicate: boolean;
}

/** Said when a step a default workflow cannot hold is picked in the Add-step menu: why, and where it can be used instead. */
export function SystemLockNote({ step, canDuplicate }: SystemLockNoteProps) {
  const { t } = useTranslation();
  const { summary } = useWorkspaceContext();
  return (
    <p role="status" className="mx-1 mb-1 rounded-md bg-info-soft p-3 text-xs" data-testid="system-lock-note">
      {t(`${B}.${canDuplicate ? "lockedStepPicked" : "lockedStepPickedStarter"}`, { step })}
      {canDuplicate ? null : (
        <>
          {" "}
          <AppLink className="font-semibold text-primary-ink underline" href={consoleRoutes.billing(summary.slug)}>{t("engage.workflows.defaults.upgrade.cta")}</AppLink>
        </>
      )}
    </p>
  );
}
